import { forwardRef } from "react";
import { bool, string, object } from "prop-types";
import { DragIndicator } from "@material-ui/icons";
import classnames from "classnames";
import useStyle from "./DragHandle.style";

export const DragHandle = forwardRef(({
  absolute,
  backgroundPrimary,
  className,
  showOnHover,
  style,
  ...otherProps
}, ref) => {
  const classes = useStyle();

  return (
    <DragIndicator
      ref={ref}
      className={classnames(
        "dragHandle",
        showOnHover && "hoverIcon",
        absolute && classes.absolute,
        backgroundPrimary && classes.backgroundPrimary,
        className
      )}
      style={style}
      {...otherProps}
    />
  );
});

DragHandle.propTypes = {
  className: string,
  backgroundPrimary: bool,
  absolute: bool,
  showOnHover: bool,
  style: object,
};
